export interface TaskTimeSetting {
  target?: number // 每周的星期几，每月的几号
  start_min: number // 离当天0点的分钟数
  end_min?: number // 离当天0点的分钟数
}

export const DefaultTaskTime = [{ target: 1, start_min: 0, end_min: 10 }]
export const DefaultEndTaskTime = [{ target: 1, start_min: 0, end_min: 23 * 60 + 50 }]
